import {
  AutoTaskResourceClient,
  AutoTaskResourceController_ResourceIdsRequest,
} from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import { useQuery } from "@tanstack/react-query";
import ms from "ms";
import type { Resource } from "shared-ui/src/features/projects-feature/canonical";
import { mapToResources } from "@features/projects-feature/toCanonical";

export const useGetResourcesByIds = (resourceIds: string[]) => {
  const api = useApi(AutoTaskResourceClient);

  const fetchResources = async (): Promise<Resource[]> => {
    const payload: AutoTaskResourceController_ResourceIdsRequest = {
      resourceIds: resourceIds.map((r) => Number(r)).filter((n) => !isNaN(n)),
    } as AutoTaskResourceController_ResourceIdsRequest;
    const response = await api.getResourcesByIds(payload);
    return mapToResources(response);
  };

  return useQuery<Resource[], Error>({
    queryKey: ["task-resources"],
    queryFn: fetchResources,
    enabled: !!resourceIds && resourceIds.length > 0,
    staleTime: ms("10m"),
  });
};

export default useGetResourcesByIds;